export const paymentStatusService = {
  getPrePayment: (data) => window.axios.post("get-pre-auth-payment", data),
  getCompletedPayment: (data) =>
    window.axios.post("get-completed-payment", data),
  getBooking: (data) => window.axios.post("get-booking-info", data),
};
